import PropTypes from 'prop-types'
import { ThemeProvider } from 'styled-components'

const ContentPresenter = ({ color, content, Layout, setContentTime }) => (
  <ThemeProvider theme={{ color }}>
    <Layout content={content} setContentTime={setContentTime} />
  </ThemeProvider>
)

ContentPresenter.defaultProps = {
  content: {},
}

ContentPresenter.propTypes = {
  color: PropTypes.string,
  content: PropTypes.object,
  Layout: PropTypes.func,
  setContentTime: PropTypes.func,
}

export default ContentPresenter
